import React, { useState } from "react";
import PropTypes from "prop-types";
import { DataGrid } from "@mui/x-data-grid";
import MDBox from "components/MDBox";
import { IconButton, Chip, Box } from "@mui/material";
import { Edit, Delete, Label } from "components/icons";

const getCategoryColor = (category) => {
  const colors = {
    DOCUMENT_TYPE: "primary",
    DEPARTMENT: "info",
    PROJECT: "success",
    TECHNOLOGY: "warning",
    GENERAL: "default",
  };
  return colors[category] || "default";
};

export const TagDataGrid = ({ tags, isLoading, onEdit, onDelete, showActions = true }) => {
  const [pageSize, setPageSize] = useState(10);

  const columns = [
    ...(showActions ? [{
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 100,
      getActions: (params) => [
        <IconButton key="edit" onClick={() => onEdit(params.row)} color="primary" size="small">
          <Edit />
        </IconButton>,
        <IconButton key="delete" onClick={() => onDelete(params.row)} color="error" size="small">
          <Delete />
        </IconButton>,
      ],
    }] : []),
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "tagName",
      headerName: "Tag Name",
      width: 200,
      flex: 1,
      renderCell: (params) => (
        <Box display="flex" alignItems="center" gap={1}>
          <Label sx={{ color: params.row.color || "#1976d2" }} />
          <Chip
            label={params.value}
            size="small"
            sx={{
              backgroundColor: params.row.color || "#1976d2",
              color: "#fff",
            }}
          />
        </Box>
      ),
    },
    {
      field: "category",
      headerName: "Category",
      width: 150,
      renderCell: (params) => (
        <Chip label={params.value?.replace("_", " ")} color={getCategoryColor(params.value)} size="small" variant="outlined" />
      ),
    },
    {
      field: "documentCount",
      headerName: "Documents",
      width: 110,
      renderCell: (params) => (
        <Chip label={params.value || 0} color={params.value > 0 ? "primary" : "default"} size="small" />
      ),
    },
    { field: "description", headerName: "Description", width: 250, flex: 1 },
    {
      field: "createdAt",
      headerName: "Created",
      width: 110,
      valueFormatter: (value) => value ? new Date(value).toLocaleDateString() : "N/A",
    },
  ];

  return (
    <MDBox pt={3} py={3} px={2} height={400}>
      <DataGrid
        rows={tags || []}
        columns={columns}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        rowsPerPageOptions={[5, 10, 20, 50]}
        loading={isLoading}
        disableSelectionOnClick
        getRowId={(row) => row.id || row.tagId}
      />
    </MDBox>
  );
};

TagDataGrid.propTypes = {
  tags: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  showActions: PropTypes.bool,
};

export default TagDataGrid;

